<template>
  <div class="saleCustomerManagement">
    <div class="public_Spacing customerManagementPC">
      <!-- 查询 -->
      <div class="pulbic_oparetionBlock">
        <div class="public_criteriaRange customerManagementPC-select" style="display: flex; align-items: center;">
          <div class="public_oparetionBlock_Menu">
            <label class="public_lbSty">客户名称：</label>
            <div class="el-select public_optionSty">
              <div class="el-input el-input--suffix">
                <el-select class="public_optionSty dropDown_Define" v-model="queryParams.SETTB410CA00" placeholder="请选择"
                  :clearable="true" filterable>
                  <el-option v-for="item in customerOptions" :key="item.ORMTB410ID" :label="item.ORMTB410CA00"
                    :value="item.ORMTB410ID">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="public_oparetionBlock_Menu">
            <label class="public_lbSty">状态:</label>
            <el-select class="public_optionSty dropDown_Define" v-model="queryParams.SETTB410CA09" placeholder="请选择"
              :clearable="true">
              <el-option label="待审核" :value="0" />
              <el-option label="已开票" :value="1" />
              <el-option label="拒绝" :value="2" />
            </el-select>
          </div>
        </div>
        <div class="public_operatArea">
          <span class="pulic_operatArea_now pulic_cursor" :class="dateNowDayActive ? 'public_dateActive' : ''"
            @click="getNowDay">当日</span>
          <span class="public_operatArea_yesterday pulic_cursor" :class="dateYesterdayActive ? 'public_dateActive' : ''"
            @click="getYesterday">昨天</span>
          <span class="pulic_operatArea_now pulic_cursor" :class="dateNowMonthActive ? 'public_dateActive' : ''"
            @click="sameMonth">当月</span>
          <span class="public_operatArea_yesterday pulic_cursor" :class="dateLastMonthActive ? 'public_dateActive' : ''"
            @click="lastMonth">上月</span>
          <div class="public_operatArea_timePicker pulic_cursor">
            <el-date-picker v-model="date" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" range-separator="至"
              :picker-options="startDateDisabled" @change="datePickerChange" start-placeholder="开始日"
              end-placeholder="结束日" class="pulic_cursor">
            </el-date-picker>
          </div>
          <div class="customerManagementPC-btn public_operatBtn" style="margin-top: 20px; margin-left: 10px;">
            <el-button class="public_saleWater_chaxun" type="primary" id="查询" @click="querycusList()" size="small">
              <i class="iconfont icon-chaxun"></i>查询
            </el-button>
          </div>
          <el-button class="public_saleWater_daochu pulic_cursor" :loading="loadingBut" @click="handleExport" id="导出"><i
              class="iconfont icon-daochu"></i>导出<span v-if="confirmTxt > 0">{{ confirmTxt }}</span></el-button>
        </div>
      </div>
      <div class="statistic">
        <div class="statistic-item">
          <i class="el-icon-search" style="color: #EEB68B;"></i>
          <span style="margin-right: 10px; color: #EBAA7A;">待审核</span>
          <span style="color: #EBAA7A;">{{ pendingReview }}(万元)</span>
        </div>
        <div class="statistic-item">
          <i class="el-icon-tickets" style="color: #86D185"></i>
          <span style="margin-right: 10px; color: #67C668;">已开票</span>
          <span style="color: #67C668;">{{ invoiced }}(万元)</span>
        </div>
      </div>
      <div class="billOperationRecord-table pulbic_table_container">
        <el-table v-loading="loading" tooltip-effect="dark" :data="tableData" style="width: 100%;"
          :default-sort="{ prop: 'waterNum', order: 'descending' }" class="public_tableColumn"
          :header-cell-style="{ color: 'rgba(51,51,51,1)', background: 'rgba(184,227,255,1)', 'font-weight': 'bold' }">
          <!--start 二级表格 -->
          <!-- <el-table-column type="expand">
            <template slot-scope="props">
              <el-table :data="props.row.detailList">
                <el-table-column prop="month" label="扣减月份"></el-table-column>
                <el-table-column prop="zed" label="扣减总额度"></el-table-column>
                <el-table-column prop="edmf" label="免服务费额度"></el-table-column>
                <el-table-column prop="edn" label="服务费8.5额度"></el-table-column>
                <el-table-column prop="edw" label="服务费8.8额度"></el-table-column>
                <el-table-column prop="ed91" label="服务费9.1额度"></el-table-column>
                <el-table-column prop="sxf" label="总服务费"></el-table-column>
                <el-table-column prop="ednsxf" label="8.5额度服务费"></el-table-column>
                <el-table-column prop="edwsxf" label="8.8额度服务费"></el-table-column>
                <el-table-column prop="ed91sxf" label="9.1额度服务费"></el-table-column>
              </el-table>
            </template>
          </el-table-column> -->
          <!--end 二级表格 -->
          <el-table-column prop="SETTB410CA10" label="申请时间" width="150">
          </el-table-column>
          <el-table-column prop="SETTB410CA01" label="申请人" width="120">
            <template slot-scope="scope">
              <div>{{ scope.row.SETTB410CA01 }}</div>
              <span>{{ scope.row.SETTB410CA02 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="SETTB410CA18" label="申请金额" width="100"></el-table-column>
          <el-table-column prop="SETTB410CA21" label="服务费"></el-table-column>
          <el-table-column prop="SETTB410CA27" label="是否已扣服务费" width="150">
            <template slot-scope="scope">
              <el-tag size="medium" v-if="scope.row.SETTB410CA27 === 0">未扣</el-tag>
              <el-tag v-if="scope.row.SETTB410CA27 === 1">已扣</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="SETTB410CA03" label="抬头"></el-table-column>
          <el-table-column prop="SETTB410CA04" label="税号" width="165"></el-table-column>
          <el-table-column prop="SETTB410CA16" fixed="right" width="auto" label="单位地址">
          </el-table-column>
          <el-table-column prop="SETTB410CA02" label="电话" fixed="right">
          </el-table-column>
          <el-table-column prop="SETTB410CA15" label="开户银行" fixed="right" width="auto">
          </el-table-column>
          <el-table-column prop="SETTB410CA05" label="银行账号" fixed="right" width="auto">
          </el-table-column>

          <el-table-column prop="SETTB410CA26" label="备注" fixed="right">
          </el-table-column>
          <el-table-column prop="SETTB410CA09" label="状态" fixed="right">
            <template slot-scope="scope">
              <el-tag size="medium" v-if="scope.row.SETTB410CA09 === 0" type="warning">待审核</el-tag>
              <el-tag size="medium" v-if="scope.row.SETTB410CA09 === 1" type="success">已开票</el-tag>
              <el-tag size="medium" v-if="scope.row.SETTB410CA09 === 3" type="success">开票中</el-tag>
              <el-tag v-if="scope.row.SETTB410CA09 === 2" type="danger">拒绝</el-tag>
              <el-tag v-if="scope.row.SETTB410CA09 === 4" type="danger">开票失败</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="SETTB410CA33" label="业务公司" fixed="right">
            <template slot-scope="scope" v-if="scope.row.SETTB410CA33">
              <span class="active_box box_blue" v-if="scope.row.SETTB410CA33 == '恒丰'">恒</span>
              <span class="active_box box_red" v-else-if="scope.row.SETTB410CA33 == '谷丰'">谷</span>
              <span class="active_box box_orange" v-else>{{ scope.row.SETTB410CA33?scope.row.SETTB410CA33.charAt(0) :''}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="200">
            <template slot-scope="scope">
              <div class="customerManagementPC-table-btn">
                <el-button
                  v-if="scope.row.SETTB410CA09 !== 1 && scope.row.SETTB410CA09 !== 2 && scope.row.SETTB410CA09 !== 3 && scope.row.SETTB410CA09 !== 4"
                  slot="reference" type="primary" size="mini" @click="handleAudit('1', scope.row)">开票</el-button>
                <el-button
                  v-if="scope.row.SETTB410CA09 !== 1 && scope.row.SETTB410CA09 !== 2 && scope.row.SETTB410CA09 !== 3 && scope.row.SETTB410CA09 !== 4"
                  slot="reference" type="danger" size="mini" @click="handleAudit('2', scope.row)">拒绝</el-button>
                <el-button v-if="scope.row.SETTB410CA09 === 1" type="success" size="mini"
                  @click="lookInstrument(scope.row)">查看票据</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="customerManagementPC-page">
          <!-- <span style="font-size: 14px;color:#606266;">共{{ this.total }}条</span> -->
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="queryParams.page" :page-sizes="[10, 20, 30, 40]" layout="total, sizes,prev, pager, next"
            :page-size="queryParams.limit" :total="this.total"></el-pagination>
        </div>
      </div>
    </div>
    <!-- 审核dialog -->
    <div class="public-dialog">
      <el-dialog :title="isShowUpload ? '开票信息' : '提示'" :visible.sync="dialogVisible" width="80%"
        :before-close="handleClose">
        <label v-if="!isShowUpload" style="font-size: 20px;">拒绝原因：</label>
        <el-input v-if="!isShowUpload" style="width: 80%;" v-model="auditParams.SETTB410CA11" :aria-required="true"
          placeholder="请输入拒绝原因" maxlength="10">
        </el-input>
        <!-- 基本信息 -->
        <div v-if="isShowUpload" class="issue-an-invoice">
          <div class="DetailsWater-Dialog">
            <div class="DWD-li">
              <div class="DWD-li-title">公司名称</div>
              <div class="DWD-li-text">{{ currentRowInfo.SETTB410CA03 }}</div>
            </div>
            <div class="DWD-li">
              <div class="DWD-li-title">税号</div>
              <div class="DWD-li-text">{{ currentRowInfo.SETTB410CA04 }}</div>
            </div>
            <div class="DWD-li">
              <div class="DWD-li-title">公司地址</div>
              <div class="DWD-li-text">{{ currentRowInfo.SETTB410CA16 }}</div>
            </div>
            <div class="DWD-li">
              <div class="DWD-li-title">开户行</div>
              <div class="DWD-li-text">{{ currentRowInfo.SETTB410CA15 }}</div>
            </div>
            <div class="DWD-li">
              <div class="DWD-li-title">银行账号</div>
              <div class="DWD-li-text">{{ currentRowInfo.SETTB410CA05 }}</div>
            </div>
            <div class="DWD-li">
              <div class="DWD-li-title">申请金额</div>
              <div class="DWD-li-text">{{ currentRowInfo.SETTB410CA18 }}</div>
            </div>
            <div class="DWD-li">
              <div class="DWD-li-title">申请人</div>
              <div class="DWD-li-text">{{ currentRowInfo.SETTB410CA01 }}</div>
            </div>
            <div class="DWD-li">
              <div class="DWD-li-title">备注</div>
              <div class="DWD-li-text">{{ currentRowInfo.SETTB410CA26 }}</div>
            </div>
          </div>
          <div class="issue-an-invoice-table">
            <div style="margin: 10px 0;">
              <el-button type="primary" size="small" @click="addRow">增行</el-button>
              <el-button size="small" @click="delRow" :disabled="delDisabled">删除</el-button>
            </div>
            <el-form>
              <el-table :data="dialogTableData" :row-style="{ height: '3.1vw' }" ref="multipleTable"
                @selection-change="selectChange">
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column prop="SETTB410CB01" label="项目名称">
                  <template slot-scope="scope">
                    <el-form-item style="margin-bottom: unset;">
                      <el-select v-model="scope.row.SETTB410CB01" value-key="SETTB410CCID" @change="selectkpxmNameFun"
                        placeholder="请输入">
                        <el-option v-for="item in projectNameList" :key="item.SETTB410CCID" :label="item.SETTB410CC00"
                          :value="item">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="SETTB410CB03" label="单位">
                  <template slot-scope="scope">
                    <el-form-item style="margin-bottom: unset;" :prop="scope.row.SETTB410CB03">
                      <el-input v-model="scope.row.SETTB410CB03" placeholder="请选择"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="SETTB410CB00" label="物料名称">
                  <template slot-scope="scope">
                    <el-form-item style="margin-bottom: unset;" :prop="scope.row.SETTB410CB00">
                      <el-select v-model="scope.row.SETTB410CB00" placeholder="请输入"></el-select>
                    </el-form-item>
                  </template>
                </el-table-column> -->
                <el-table-column prop="SETTB410CB02" label="规格型号">
                  <template slot-scope="scope">
                    <el-form-item style="margin-bottom: unset;" :prop="scope.row.SETTB410CB02">
                      <el-input v-model="scope.row.SETTB410CB02" placeholder="请输入"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>

                <el-table-column prop="SETTB410CB04" label=" 数量">
                  <template slot-scope="scope">
                    <el-form-item style="margin-bottom: unset;" :prop="scope.row.SETTB410CB04">
                      <el-input v-model="scope.row.SETTB410CB04" type="number" :min="0" placeholder="请输入"
                        @input="changeCount(scope.row.index)"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="SETTB410CB05" label=" 单价(含税)">
                  <template slot-scope="scope">
                    <el-form-item style="margin-bottom: unset;" :prop="scope.row.SETTB410CB05">
                      <el-input v-model="scope.row.SETTB410CB05" type="number" :min="0" placeholder="请输入"
                        @input="changePrice(scope.row.index)"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="SETTB410CB06" label="开票金额(含税)">
                  <template slot-scope="scope">
                    <el-form-item style="margin-bottom: unset;" :prop="scope.row.SETTB410CB06">
                      <el-input v-model="scope.row.SETTB410CB06" type="number" :min="0" placeholder="请输入"
                        @input="changeInvoiceAmount(scope.row.index)"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="SETTB410CA28" label="备注">
                  <template slot-scope="scope">
                    <el-form-item style="margin-bottom: unset;" :prop="scope.row.SETTB410CA28">
                      <el-input v-model="scope.row.SETTB410CA28" placeholder="请输入"
                        @input="changeCount(scope.row.index)"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column> -->
                <!-- <el-table-column prop="SETTB410CB07" label="税率/征收率">
                  <template slot-scope="scope">
                    <el-form-item style="margin-bottom: unset;" :prop="scope.row.SETTB410CB07">
                      <el-select v-model="scope.row.SETTB410CB07" placeholder="请输入"
                        @change="changeTaxRate(scope.row.index)"></el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="SETTB410CB08" label=" 税额">
                  <template slot-scope="scope">
                    <el-form-item style="margin-bottom: unset;" :prop="scope.row.SETTB410CB08">
                      <el-input v-model="scope.row.SETTB410CB08" placeholder="请输入"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column> -->
              </el-table>
            </el-form>
          </div>
          <div class="kpbz-style">
            <span style="width: 50px; line-height: 50px;">备注：</span>
            <el-input type="textarea" placeholder="请输入" v-model="auditParams.SETTB410CA28"></el-input>
          </div>
        </div>
        <!-- 上传发票 -->
        <!-- <div v-if="isShowUpload" style="margin: 10px 0;">请上传发票:</div>
        <div v-if="isShowUpload">
          <el-upload :class="{ disabled: uploadDisabled }" ref="upload" :auto-upload="false" action=""
            :on-change="handleChange" :on-exceed="handleExceed" :file-list="fileList" :accept="acceptFormat"
            :limit="limitNum" :multiple="false" drag>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip" style="font-size:20px; color: red;">
              只能上传{{ acceptFormat }}格式的文件，每次上传的文件数量不能超过{{ limitNum }}个</div>
          </el-upload>
        </div> -->

        <span slot="footer" class="dialog-footer">
          <el-button @click="closeFpqxFun">取 消</el-button>
          <el-button type="primary" @click="submitAudit">{{ submitText }}</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- <div class="public-dialog">
      <el-dialog title="查看发票" :visible.sync="isShowInstrument" style="padding: 20px;">
        <el-image style="width: 100%; height: 50%" :src="instrumentImgUrl" alt="暂无图片" fit="fit"></el-image>
      </el-dialog>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      uobj: this.$store.state.uobj, //登陆缓存--用户信息
      loading: false,
      customerOptions: [{
        ORMTB410ID: '',
        ORMTB410CA00: '全部',
      }],
      pendingReview: '', // 待审核
      invoiced: '', // 已开票
      queryParams: {
        SETTB410CA00: '', // 客户名称
        SETTB410CA09: '', //状态
        startTime: '',
        endTime: '',
        page: 1,
        limit: 10
      },
      auditParams: {
        SETTB410ID: '', //主键
        SETTB410CA09: '', //状态：0，申请，1，已开票，2，拒绝
        SETTB410CA11: '', //拒绝原因
        //SETTB410CA12: '',
        SETTB410CA28: '',// 备注
        Settb410InvoiceItems: []
      },
      date: [],
      // 限制开始日期不能超过当前日期
      startDateDisabled: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      dateNowDayActive: false,
      dateYesterdayActive: false,
      dateNowMonthActive: false,
      dateLastMonthActive: false,
      loadingBut: false,
      confirmTxt: 0,
      total: 0,
      totalPage: 0,
      tableData: [],
      dialogTableData: [{
        index: 0,
        SETTB410CB01: '', // 编码名称
        SETTB410CB00: '', // 项目名称
        SETTB410CB03: '吨', //单位
        SETTB410CB02: '', // 规格型号
        SETTB410CB06: '', //开票金额
        SETTB410CB05: '', //单价
        SETTB410CB04: '', //数量
        // SETTB410CB07: '', //税率
        // SETTB410CB08: '' //税额
      }],
      invoiceAmount: '',
      price: '',
      count: '',
      lastCalculated: null, // 记录上次计算的是哪个值
      dialogVisible: false,
      isShowUpload: false,
      type: '',
      auditInfo: '',
      submitText: '',
      // limitNum: 1, // 限制每次上传的文件数量
      // // acceptFormat: '.pdf', // 支持上传的文件格式
      // fileList: [],
      // addimg: [],
      fpdialogImageUrl: '', //票据URL
      solelist: [], //权限列表
      currentRowInfo: {},
      delDisabled: true,
      checkedRow: [],
      projectNameList: [],
      isShowInstrument: false,
      instrumentImgUrl: '',
    };
  },
  created() {
    this.enterprise0ptions()
    this.getPermissionList()
    this.querycusList()
  },
  methods: {
    // 列表查询
    querycusList() {
      this.loading = true
      const url = '/set/settb410Entity/settb410ListAdmin';
      this.axios.post(url, this.queryParams).then(res => {
        if (res.status === 200) {
          if (res.data.code === 200) {
            const { data: { data } } = res
            console.log(data);
            this.pendingReview = data.applyData.SETTB410CA18
            this.invoiced = data.totalData.SETTB410CA18
            this.tableData = data.list
            this.total = data.total;
            this.totalPage = data.totalPage
          } else {
            this.$message({
              message: res.data.message,
              type: 'error'
            })
          }
        }
        this.loading = false
      })
    },
    // 导出
    handleExport() {
      let token = sessionStorage.getItem('token');
      var startTime;
      var endTime;
      if (this.date.length) {
        startTime = this.date[0]; //开始时间
        endTime = this.date[1]; //结束时间
      } else {
        startTime = '' //开始时间
        endTime = '' //结束时间
      }

      var SETTB410CA00 = this.queryParams.SETTB410CA00;
      var SETTB410CA09 = this.queryParams.SETTB410CA09;
      var url = this.axios.defaults.baseURL + "/set/settb410Entity/ormtb421toExcle?startTime=" + startTime +
        "&endTime=" +
        endTime + '&token=' + token + "&SETTB410CA00=" + SETTB410CA00 + "&SETTB410CA09=" + SETTB410CA09;
      window.location.href = url;

      this.loadingBut = true
      var timer = null //倒计时
      this.confirmTxt = 30 - 1
      timer = setInterval(() => {
        if (this.confirmTxt === 0) {
          this.confirmTxt = ""
          this.loadingBut = false
          clearInterval(timer);
        } else {
          this.confirmTxt--
        }
      }, 1000);
    },
    // 通过、拒绝
    handleAudit(type, row) {
      if (type === '1') {
        this.isShowUpload = true
        this.currentRowInfo = row
        this.dialogTableData = [{
          index: 0,
          SETTB410CB01: '', // 编码名称
          SETTB410CB00: '', // 项目名称
          SETTB410CB03: '吨', //单位
          SETTB410CB02: '', // 规格型号
          SETTB410CB06: '', //开票金额
          SETTB410CB05: '', //单价
          SETTB410CB04: '' //数量
        }]
        this.auditParams.SETTB410CA09 = 1
        this.submitText = '开票'
        this.auditInfo = '确定通过该条申请吗？'
      }
      if (type === '2') {
        this.isShowUpload = false
        this.auditParams.SETTB410CA09 = 2
        this.submitText = '拒绝'
        this.auditInfo = '确定拒绝该条申请吗？'
      }
      this.dialogVisible = true
      this.type = type
      // 入参
      const data = {
        SETTB410ID: row.SETTB410ID, //主键
        SETTB410CA09: this.auditParams.SETTB410CA09, //状态：0，申请，1，已开票，2，拒绝
        SETTB410CA11: row.SETTB410CA11 === null ? '' : row.SETTB410CA11, //拒绝原因
        SETTB410CA13: row.SETTB410CA13 === null ? '' : row.SETTB410CA13 // 审核人
        //SETTB410CA12: ''
      }
      this.auditParams = data
      this.getProductList(row.ORMTB410ID)
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
    },
    selectkpxmNameFun(val) {
      console.log(val);
      console.log(this.dialogTableData)

      // this.dialogTableData.map(item => {
      // 	 item.SETTB410CB01 = val.SETTB410CC01
      // 	item.SETTB410CB00 = val.SETTB410CC00
      // })
      console.log(this.dialogTableData)
      // this.dialogTableData.SETTB410CB01 = val.SETTB410CC01
      // this.dialogTableData.SETTB410CB00 = val.SETTB410CC00
    },
    // 上传发票
    // handleChange(file, fileList) {
    //   console.log(fileList);
    //   this.addimg = fileList[0].raw;
    //   this.fileList = []
    //   const formData = new FormData();
    //   formData.append("file", this.addimg);
    //   // formData.append('ORMTB470CA00', this.ORMTB470CA00)
    //   let loading = this.$loading({
    //     lock: true,
    //     text: '上传中...',
    //     spinner: 'el-icon-loading',
    //     background: 'rgba(0, 0, 0, 0.5)'
    //   });
    //   var url = "/system/uploadBD";
    //   this.axios.post(url, formData, {
    //     headers: {
    //       'Content-Type': 'multipart/form-data'
    //     }
    //   }).then(res => {
    //     setTimeout(() => {
    //       loading.close()
    //     }, 400)
    //     if (res.data.code == 200) {
    //       console.log(res)
    //       this.$message({
    //         message: '上传成功',
    //         type: 'success'
    //       });
    //       this.fpdialogImageUrl = res.data.data.bdurl
    //       console.log(this.fpdialogImageUrl);

    //       this.fileList = fileList
    //       this.hdPDFsb()
    //     } else {
    //       this.$message({
    //         message: res.data.message,
    //         type: 'error'
    //       });
    //     }
    //   }).catch(() => {
    //     loading.close();
    //   })
    // },
    //控制上传数量提示
    // handleExceed(files, fileList) {
    //   this.$message.warning(`最多上传1个文件`);
    // },

    closeFpqxFun() {
      this.dialogVisible = false
      this.dialogTableData = [{
        index: 0,
        SETTB410CB01: '', // 编码名称
        SETTB410CB00: '', // 项目名称
        SETTB410CB03: '吨', //单位
        SETTB410CB02: '', // 规格型号
        SETTB410CB06: '', //开票金额
        SETTB410CB05: '', //单价
        SETTB410CB04: '', //数量
        // SETTB410CB07: '', //税率
        // SETTB410CB08: '' //税额
      }]
      this.auditParams.SETTB410CA28 = ''
    },

    // 提交
    submitAudit() {
      if (this.type === '1') {
        var sum = 0;
        this.dialogTableData.forEach(item => {
          sum += parseFloat(parseFloat(item.SETTB410CB06).toFixed(2))
        })
        const arr = this.dialogTableData.map(item => {
          // item.SETTB410CB01 = item.SETTB410CB01.SETTB410CC01
          console.log(item)
          console.log(this.projectNameList)
          const arr = this.projectNameList.filter(el => { if (el.SETTB410CC00 == item.SETTB410CB01.SETTB410CC00) return el.SETTB410CC00 })
          console.log(arr)
          return {
            ...item,
            SETTB410CB00: arr[0].SETTB410CC00,
            SETTB410CB01: item.SETTB410CB01.SETTB410CC01
          }
        })
        console.log(arr);

        this.auditParams.Settb410InvoiceItems = arr

        sum = sum.toFixed(2);
        if (sum > this.currentRowInfo.SETTB410CA18) {
          return this.$message({
            message: '开票金额不能大于申请金额',
            type: 'warning'
          })
        }
        console.log(this.auditParams)

        //this.auditParams.SETTB410CA12 = this.fpdialogImageUrl
        const url = '/set/settb410Entity/settb410AuditAdmin'
        this.axios.post(url, this.auditParams).then(res => {
          console.log(res);
          if (res.data.code === 200) {
            this.querycusList()
            this.dialogVisible = false
            this.$message({
              message: res.data.data,
              type: 'success'
            })
            this.dialogVisible = false
            this.dialogTableData = [{
              index: 0,
              SETTB410CB01: '', // 编码名称
              SETTB410CB00: '', // 项目名称
              SETTB410CB03: '吨', //单位
              SETTB410CB02: '', // 规格型号
              SETTB410CB06: '', //开票金额
              SETTB410CB05: '', //单价
              SETTB410CB04: '', //数量
              // SETTB410CB07: '', //税率
              // SETTB410CB08: '' //税额
            }]
          } else {
            this.$message({
              message: res.data.message,
              type: 'warning'
            })
          }
        }).catch(err => {
          this.dialogVisible = false
          this.$message({
            message: '请求失败，请稍后重试',
            type: 'error'
          })
        })
      } else {
        if (!this.auditParams.SETTB410CA11.trim()) {
          this.$message({
            message: '拒绝原因必填',
            type: 'warning'
          })
          return
        }
        const url = '/set/settb410Entity/settb410AuditAdmin'
        this.axios.post(url, this.auditParams).then(res => {
          console.log(res);
          if (res.data.code === 200) {
            this.querycusList()
            this.dialogVisible = false
            this.$message({
              message: res.data.data,
              type: 'success'
            })
          } else {
            this.dialogVisible = false
            this.$message({
              message: res.data.message,
              type: 'warning'
            })
          }
        }).catch(err => {
          this.dialogVisible = false
          this.$message({
            message: '请求失败，请稍后重试',
            type: 'error'
          })
        })
      }
    },
    // 时间切换
    datePickerChange(e) {
      console.log(e);

      if (e !== null) {
        this.queryParams.startTime = e[0]
        this.queryParams.endTime = e[1]
        this.dateNowDayActive = false
        this.dateYesterdayActive = false
        this.dateNowMonthActive = false
        this.dateLastMonthActive = false
      } else {
        this.queryParams.startTime = ''
        this.queryParams.endTime = ''
      }

    },
    //获取当前时间
    getNowDay() {
      var date = new Date().getTime();
      var Ming = new Date().getTime() + 24 * 60 * 60 * 1000;
      var data = this.dateFtt('yyyy-MM-dd', new Date(Ming))
      var enddata = this.dateFtt('yyyy-MM-dd', new Date(date))
      data = `${data} ${this.exchangeTiem || '00:00:00'}`
      enddata = `${enddata} ${this.exchangeTiem || '00:00:00'}`
      this.date = [enddata, data];
      this.queryParams.startTime = this.date[0]
      this.queryParams.endTime = this.date[1]
      this.dateNowDayActive = true
      this.dateYesterdayActive = false
      this.dateNowMonthActive = false
      this.dateLastMonthActive = false
    },
    //获取昨天时间
    getYesterday() {
      var hms = new Date().getTime() - 24 * 60 * 60 * 1000;
      var Ming = new Date().getTime();
      var nowDay = this.dateFtt('yyyy-MM-dd', new Date(hms))
      var enddata = this.dateFtt('yyyy-MM-dd', new Date(Ming))
      nowDay = `${nowDay} ${this.exchangeTiem || '00:00:00'}`
      enddata = `${enddata} ${this.exchangeTiem || '00:00:00'}`
      this.date = [nowDay, enddata];
      this.queryParams.startTime = this.date[0]
      this.queryParams.endTime = this.date[1]
      this.dateNowDayActive = false
      this.dateYesterdayActive = true
      this.dateNowMonthActive = false
      this.dateLastMonthActive = false
    },
    //获取当月时间
    sameMonth() {
      var date = new Date();
      var hms = date.setDate(1);
      var firstDay = this.dateFtt('yyyy-MM-dd', new Date(hms));
      firstDay = `${firstDay} ${this.exchangeTiem || '00:00:00'}`
      var nextdate = new Date().getTime() + 24 * 60 * 60 * 1000;
      var nextDay = this.dateFtt('yyyy-MM-dd', new Date(nextdate));
      nextDay = `${nextDay} ${this.exchangeTiem || '00:00:00'}`
      this.date = [firstDay, nextDay];
      this.queryParams.startTime = this.date[0]
      this.queryParams.endTime = this.date[1]
      this.queryParams.startTime = this.date[0];
      this.queryParams.endTime = this.date[1];
      this.dateNowDayActive = false
      this.dateYesterdayActive = false
      this.dateNowMonthActive = true
      this.dateLastMonthActive = false
    },
    //获取上月时间
    lastMonth() {
      var nowdays = new Date();
      var year = nowdays.getFullYear();
      var month = nowdays.getMonth();
      var lastyear = year
      var lastmonth = month
      if (month == 0) {
        month = 12;
        year = year - 1;
      }
      if (month == 12) {
        lastmonth = 1
      } else {
        lastmonth = lastmonth + (1 * 1)
      }
      if (month < 10) {
        month = "0" + month;
      }
      if (lastmonth < 10) {
        lastmonth = "0" + lastmonth;
      }
      var firstDayOfPreMonth = year + "-" + month + "-" + "01";
      var firstDayOfPreMonth = `${year}-${month}-01 ${this.exchangeTiem || '00:00:00'}`;
      // var lastDay = new Date(lastyear, lastmonth, 0);
      let lastDayOfPreMonth = `${lastyear}-${lastmonth}-01 ${this.exchangeTiem || '00:00:00'}`;
      this.date = [firstDayOfPreMonth, lastDayOfPreMonth];
      this.queryParams.startTime = this.date[0]
      this.queryParams.endTime = this.date[1]
      this.dateNowDayActive = false
      this.dateYesterdayActive = false
      this.dateNowMonthActive = false
      this.dateLastMonthActive = true
    },
    dateFtt(fmt, date) { //author: meizz
      var o = {
        "M+": date.getMonth() + 1, //月份 
        "d+": date.getDate(), //日 
        "h+": date.getHours(), //小时 
        "m+": date.getMinutes(), //分 
        "s+": date.getSeconds(), //秒 
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度 
        "S": date.getMilliseconds() //毫秒 
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k])
            .length)));
      return fmt;
    },
    //分页切换
    handleCurrentChange(e) {
      this.queryParams.page = e
      this.querycusList()
    },
    // 条数切换
    handleSizeChange(e) {
      this.queryParams.limit = e
      this.querycusList()
    },
    // 添加行
    addRow() {
      this.dialogTableData.push({
        index: this.dialogTableData.length,
        SETTB410CB01: '', // 物料名称
        SETTB410CB03: '吨', //单位
        SETTB410CB00: '', //物料名称
        SETTB410CB02: '', // 规格型号
        SETTB410CB06: '', //开票金额
        SETTB410CB05: '', //单价
        SETTB410CB04: '', //数量
        SETTB410CB07: '', //税率
        SETTB410CB08: '' //税额
      })
    },
    // 删除行
    delRow() {
      const ids = this.checkedRow.map(item => item.index)
      const arr = this.dialogTableData.filter(item => !ids.includes(item.index));
      const newArr = arr.map((item, index) => {
        return {
          ...item,
          index: index
        }
      })
      this.dialogTableData = newArr
      this.$refs.multipleTable.clearSelection();
    },
    selectChange(e) {
      if (e.length) {
        this.checkedRow = e
        this.delDisabled = false
      } else {
        this.delDisabled = true
      }
    },
    // 自动计算 单价或数量
    changeInvoiceAmount(index) {
      console.log(this.dialogTableData[index].SETTB410CB06)
      if (this.dialogTableData[index].SETTB410CB06) {
        if (this.dialogTableData[index].SETTB410CB05) {
          this.dialogTableData[index].SETTB410CB04 = (parseFloat(this.dialogTableData[index].SETTB410CB06) / parseFloat(this.dialogTableData[index].SETTB410CB05)).toFixed(6)
        } else if (this.dialogTableData[index].SETTB410CB04) {
          this.dialogTableData[index].SETTB410CB05 = (parseFloat(this.dialogTableData[index].SETTB410CB06) / parseFloat(this.dialogTableData[index].SETTB410CB04)).toFixed(6)
        }
        else {

        }
      }
    },
    // 自动计算数量或金额
    changePrice(index) {
      if (this.dialogTableData[index].SETTB410CB05) {
        if (this.dialogTableData[index].SETTB410CB06) {
          this.dialogTableData[index].SETTB410CB04 = (parseFloat(this.dialogTableData[index].SETTB410CB06) / parseFloat(this.dialogTableData[index].SETTB410CB05)).toFixed(6)
        } else if (this.dialogTableData[index].SETTB410CB04) {
          this.dialogTableData[index].SETTB410CB06 = (parseFloat(this.dialogTableData[index].SETTB410CB05) * parseFloat(this.dialogTableData[index].SETTB410CB04)).toFixed(6)
        } else {

        }
      }
    },
    // 自动计算单价或金额
    changeCount(index) {
      if (this.dialogTableData[index].SETTB410CB04) {
        if (this.dialogTableData[index].SETTB410CB06) {
          this.dialogTableData[index].SETTB410CB05 = (parseFloat(this.dialogTableData[index].SETTB410CB06) / parseFloat(this.dialogTableData[index].SETTB410CB04)).toFixed(6)
        } else if (this.dialogTableData[index].SETTB410CB05) {
          this.dialogTableData[index].SETTB410CB06 = (parseFloat(this.dialogTableData[index].SETTB410CB05) * parseFloat(this.dialogTableData[index].SETTB410CB04)).toFixed(6)
        } else {

        }
      }
    },
    // 客户--查询
    enterprise0ptions() {
      var postData = {}
      // console.log(this.uobj)
      if (this.uobj.pertb005.pertb005cb00 == "CUS-2") {
        postData = {
          ORMTB400ID: this.uobj.ormtb410.ORMTB410ID //一级企业id
        }
      }
      if (this.uobj.pertb005.pertb005cb00 == "CUS-1") {
        postData = {
          ORMTB400ID: this.uobj.ormtb400.ORMTB400ID //一级企业id
        }
      }

      var List = [{
        ORMTB410ID: '',
        ORMTB410CA00: '全部',
      }];
      var url = "/orm/ormtb410/selectOrmtb410s";
      this.axios.post(url, postData).then(res => {
        if (res.data.code == 200) {
          // 客户
          this.customerOptions = [...List, ...res.data.data];
        } else {
          this.$message({
            message: res.data.message,
            type: 'error'
          });
        }
      })
    },
    // 获取权限列表
    getPermissionList() {
      const list = this.$store.state.solelist;
      const path = this.$route.path;
      if (path === "/saleCustomerInvoice") {
        path = "/Home" + path;
      }
      this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
      console.log(this.solelist);

    },
    // 获取开票项目名称
    getProductList(id) {
      const url = '/set/settb410/productList'
      this.axios.post(url, { SETTB410ID: id }).then(res => {
        if (res.data.code === 200) {
          this.projectNameList = res.data.data
          console.log(this.projectNameList)
        } else {
          this.$message({
            message: res.data.message,
            type: 'error'
          })
        }
      }).catch(error => {
        console.log(error);
      })
    },
    //查看票据
    lookInstrument(row) {
      console.log(row)
      // this.isShowInstrument = true
      // this.instrumentImgUrl = row.SETTB410CA12
      window.open(row.SETTB410CA12)
    }
  }
};
</script>

<style>
.carDialogTitle {
  font-weight: bold;
  line-height: 60px;
  color: rgb(0, 163, 255);
}

.customerManagementPC {
  background-color: #f3f3f3;
}

.DWD-li {
  display: flex;
  height: 35px;
  line-height: 35px;
  box-sizing: border-box;
  border: 1px solid #999;
  font-size: 16px;
  color: #333;
}

.DWD-li>div {
  padding: 0 5px;
  height: 34px;
  overflow: hidden;
  box-sizing: border-box;
}

.DWD-li-title {
  width: 100px;
  text-align: center;
  border-right: 1px solid #999;
  background-color: rgba(0, 163, 255, .1);
}

.DWD-li+.DWD-li {
  border-top: none;
}

.DWD-table {
  display: flex;
}

.DWD-table-left-flex {
  flex: 1;
}

.DWD-table>div>div {
  padding: 0 5px;
  height: 35px;
  line-height: 35px;
  overflow: hidden;
  text-align: center;
  border-right: 1px solid #999;
  border-bottom: 1px solid #999;
  box-sizing: border-box;
}

.DWD-table>div>div:first-child {
  background-color: rgba(0, 163, 255, .1);
}

.DWD-table-left-title>div {
  width: 101px;
  text-align: center;
  background-color: rgba(0, 163, 255, .1);
}

.DWD-table .DWD-table-left-title>div {
  padding: 0 5px;
  height: 35px;
  line-height: 35px;
  overflow: hidden;
  box-sizing: border-box;
  border-left: 1px solid #999;
  border-bottom: 1px solid #999;
}

.DetailsWater-img {
  margin-top: 30px;
}

.DetailsWater-img-text {
  display: inline-block;
  width: 101px;
  text-align: center;
  vertical-align: top;
}

.customerManagementPC-select .public_oparetionBlock_Menu:first-child {
  margin-left: 0;
}

.customerManagementPC-btn {
  text-align: left;
  margin-bottom: 20px;
}

.customerManagementPC-btn i {
  margin-right: 10px;
}

.customerManagementPC-table {
  padding: 30px 20px 0;
}

.customerManagementPC-table-btn i {
  display: flex;
  justify-content: space-around;
  font-size: 12px;
  margin-right: 5px;
}

.customerManagementPC-add-customer {
  padding-left: 20px;
}

.customerManagementPC-add-customer-li {
  display: flex;
  text-align: center;
  font-size: 16px;
  height: 42px;
  line-height: 42px;
}

.customerManagementPC-add-customer-li>div {
  border: 1px solid #cdcdcd;
  border-top: none;
}

.customerManagementPC-add-customer-li:first-child>div {
  border-top: 1px solid #cdcdcd;
}

.customerManagementPC-add-customer-li>div:first-child {
  border-right: none;
}

.customerManagementPC-add-customer-li>div:last-child {
  border: none;
  color: #ff4d35;
}

.customerManagementPC-add-customer-li-name {
  flex: 1;
}

.customerManagementPC-add-customer-li-ipt {
  flex: 1;
  box-sizing: border-box;
}

.customerManagementPC-add-customer-li-ipt input {
  border: none;
  outline: none;
  width: 100%;
  height: 37px;
  box-sizing: border-box;
  vertical-align: top;
  padding-left: 5px;
  text-align: center;
  font-size: 16px;
}

.customerManagementPC-add-customer-li-type {
  flex: 0.3;
}

.customerManagementPC-add-customer-btn {
  text-align: center;
  margin: 30px 0 20px 0;
}

.public-chech-details-table {
  margin-top: 20px;
  max-height: 500px;
  overflow-y: auto;
}

.public-chech-details-table-no-text {
  line-height: 80px;
  text-align: center;
  border-bottom: 1px solid #cdcdcd;
}

.customerManagementPC-page {
  margin-top: 20px;
  text-align: right;
}

.CustomerfillingDig-priceNumtext {
  font-weight: 500;
  font-size: 18px;
  line-height: 40px;
  padding: 20px 0 20px 10px;
  color: #333;
}

.CustomerfillingDig-priceNumtext span {
  color: rgba(175, 181, 4, 1.0);
  margin-left: 10px;
  font-size: 20px;
}

.fontBlue {
  color: rgba(25, 159, 255, 1) !important;
}

.billOperationRecord {
  background-color: #f3f3f3;
}

.billOperationRecord-border {

  /* border-top: 2px solid rgba(205,205,205,.4); */
  border-top: none;
  box-sizing: border-box;
  margin-right: 40px;
}

.billOperationRecord th,
.billOperationRecord td {
  text-align: center;
}

.customerRecharge-table {
  box-sizing: border-box;
}

.CustomertopUpDig-content-table-btn>.public_saleWater_lieSet {
  border-color: rgba(254, 172, 0, 1) !important;
}

.CustomerfillingDig-tab {
  padding-left: 20px;
}

.CustomerfillingDig-tab-li,
.rechargeType-tab-li {
  display: flex;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  color: #333;
  vertical-align: top;
}

.CustomerfillingDig-tab-li>div {
  border: 1px solid #CDCDCD;
  border-top: none;
}

.CustomerfillingDig-tab-li>div:first-child {
  border-right: none;
}

.CustomerfillingDig-tab-li:first-child>div {
  border-top: 1px solid #CDCDCD;
}

.CustomerfillingDig-tab-li>div:last-child,
.rechargeType-tab-li>div:last-child {
  border: none;
  color: #FF4D35;
}

.CustomerfillingDig-tab-li-text {
  flex: .8;
  background: rgba(240, 252, 255, 1);
}

.CustomerfillingDig-tab-li-ipt {
  flex: .8;
}

.rechargeType-tab-li-text {
  flex: .35;
}

.rechargeType-tab-li-ipt {
  flex: .7;
}

.CustomerfillingDig-tab-li-ipt input,
.rechargeType-tab-li-ipt input {
  height: 46px;
  width: 100%;

  text-align: center;

  box-sizing: border-box;
  font-size: 16px;
  color: #333;
}

.CustomerfillingDig-tab-li-ipt input {
  outline: none;
  border: none;
  vertical-align: top;
}

.rechargeType-tab-li-ipt input {
  /* border-radius: 8px; */
  /* outline: none; */
}

.CustomerfillingDig-tab-li-b,
.rechargeType-tab-li-b {
  flex: .3;
}

.CustomerfillingDig-tab-btn {
  text-align: center;
  margin-top: 30px;
}

.rechargeType-tab-btn {
  margin-top: 80px !important;
}

.billOperationRecord-page {
  padding-right: 40px;
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}

.salesWatersStatisticsPC-saleWaterDetails-btn {
  margin-bottom: 20px;
}

.salesWatersStatisticsPC-saleWaterDetails-btn i {
  margin-right: 10px;
}

.el-dropdown-link {
  cursor: pointer;
}

.el-table--scrollable-y .el-table__body-wrapper {
  overflow: auto;
}

.public_tableColumn .el-table__body-wrapper {
  overflow: auto !important;
}

.public_icon_width {
  width: 80px;
}

.levelmang-title {
  display: flex;
  color: #333;
  text-align: center;
  margin-bottom: 20px;

}

.levelmang-title div {
  padding: 10px 20px;
  background-color: #e3e3e3;
}

.levelmang-title .levelmang-title-active {
  background-color: #199FFF;
  color: #FFF;
}

.levelmang-table {
  border: 1px solid #e3e3e3;
}

.levelmang-table>li {
  display: flex;
}

.levelmang-table-head {
  text-align: center;
  background-color: #30A8FF;
  color: #FFF;
}

.levelmang-table-head>div {
  height: 50px;
  line-height: 50px;
  border-left: 1px solid #e3e3e3;
  box-sizing: border-box;
  overflow: hidden;
}

.levelmang-table-head>div:first-child {
  border: none;
}

.levelmang-table-CQ {
  flex: 1;
  position: relative;
  padding: 5px 10px;
}

.levelmang-table-CQ-list {
  border-bottom: 1px solid #e3e3e3;
}

.levelmang-table-JB {
  width: 240px;
}

.levelmang-table-KJ,
.levelmang-table-ZK,
.levelmang-table-YH {
  width: 295px;
}

.levelmang-table-ZK input,
.levelmang-table-YH input {
  text-align: center;
}

.levelmang-table-li {
  text-align: center;
}

.levelmang-table-li-tab-li {

  border-bottom: 1px solid #e3e3e3;
}

.levelmang-table-li-tab-li:last-child {
  /* border: none; */
}

.levelmang-table-li-tab-li>div {
  border-left: 1px solid #e3e3e3;
  padding: 0 10px;
  box-sizing: border-box;
  height: 50px;
  line-height: 50px;
  vertical-align: top;
  overflow: hidden;
}

.levelmang-table-li-tab-li>div>input {
  width: 100px;
  border: 1px solid #e3e3e3;
  height: 35px;
  line-height: 35px;
  border-radius: 5px;
  margin-right: 10px;
}

.levelmang-table-CQ>div {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
}

.levelmang-table-li-tab-li {
  display: flex;
}

.userfptj {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}

.billOperationRecord-table {
  padding: 30px 20px 0;
}

.issue-an-invoice-table .el-table th>.cell {
  color: black;
}

.kpbz-style {
  display: flex;
  width: 360px;
  padding: 20px 0;
  padding-top: 100px;
  justify-content: center;
}

.statistic {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  width: 100%;
  height: 5vw;
}

.statistic-item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 49.6%;
  height: 100%;
  vertical-align: middle;
  font-size: 30px;
  background-color: #fff;
}

.statistic-item i {
  margin-top: 5px;
  margin-right: 10px;
}

.active_box {
  display: inline-block;
  width: 26px;
  height: 26px;
  line-height: 26px;
  border-radius: 6px;
  font-size: 13px;
}

.box_blue {
  background-color: #c1e2fd;
  color: rgb(4, 104, 235);
}

.box_red {
  background-color: #f7eaea;
  color: #ff3c35;
}

.box_orange {
  background-color: #f5ce9a;
  color: #e99802;
}
</style>